<div class="bo-main-logo" routerLink="/data-publishing">
  <img [ngSrc]="imgPath" alt="Main Logo" width="27" height="19" priority />
</div>
